import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `Please provide a link by forking these links `, /*#__PURE__*/React.createElement("a", {
    href: "https://u.ant.design/reproduce",
    target: "_blank"
  }, `antd@5.x`), ` / `, /*#__PURE__*/React.createElement("a", {
    href: "https://u.ant.design/codesandbox-repro-4x",
    target: "_blank"
  }, `antd@4.x`), ` or GitHub repo.
`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#repro-modal"
    }
  }, `What is a minimal reproduction, and why is it required?`)));
};